
<template lang="pug">
.flex.flex-center.fit
  .login__frame
    .login__title レジ稼働計画

    q-field.q-my-lg(:error="errors.username || errors.message !== false")
      q-input(
        ref="input_username"
        v-model.trim="auth.username"
        float-label="アカウント名を入力してください"
        name="user_id"
        @keyup.enter="onSubmit"
      )

    q-field.login__password.q-mb-lg(
      :error="errors.password || errors.message !== false"
      :error-label="errors.message || ''"
    )
      q-input(
        ref="input_password"
        v-model.trim="auth.password"
        float-label="パスワードを入力してください"
        name="password"
        type="password"
        @keyup.enter="onSubmit"
      )

    q-btn.float-right(
      color="primary"
      @click="onSubmit"
    ) ログイン

  .login__version(v-if="versionString") ver {{versionString}}
</template>

<script>
import {flatten, get} from 'lodash-es'

import {mapGetters, mapActions} from 'vuex'
import AxiosMixin from 'mixins/axios'

export default {
  mixins: [AxiosMixin],

  data() {
    return {
      auth: {
        username: '',
        password: '',
      },
      errors: {
        username: false,
        password: false,
        message:  false,
      },
    }
  },

  computed: {
    ...mapGetters(['versionString']),
  },

  methods: {
    ...mapActions(['fetchConfig']),

    async onSubmit() {
      this.errors.username = !this.auth.username
      this.errors.password = !this.auth.password
      this.errors.message  = false

      if(this.errors.username) {
        this.$refs.input_username.focus()
        return
      }
      if(this.errors.password) {
        this.$refs.input_password.focus()
        return
      }

      try{
        await this.axios.post('/api/login', this.auth)
        await this.fetchConfig()
      }
      catch(e) {
        // TODO: エラー対処はもっと汎用化したほうがいい？
        const errors = get(e, 'response.data.errors')
        if(errors) {
          this.errors.message = flatten(Object.values(errors))[0]
          return
        }
        this.$handler(e)
      }
    },
  },
}
</script>

<style lang="sass">
.login__frame
  padding: 20px
  width: 300px

.login__title
  font-size: 120%
  margin-bottom: 16px
  text-align: center

.login__password
  height: 66px

.login__version
  font-family: sans-serif
  font-size: 11px
  position: fixed
  right: 4px
  top: 2px

</style>
